<template>
  <div class="space-y-24">
    <div class="flex items-center gap-16 sm:flex-col sm:items-start">
      <TextIcon
        icon="svguse:#icon_target"
        text="My Quick Wins"
        icon-class="text-primary-pure"
        :div-class="
          titleSmall
            ? 'text-headline-1 !gap-12 !font-normal'
            : '!gap-12 !font-normal'
        "
      />

      <div
        class="flex flex-1 items-center gap-16 justify-end flex-nowrap sm:w-full"
      >
        <div
          class="grid grid-cols-2 gap-8 sm:grid-cols-1 sm:w-full flex-1"
        >
          <div
            class="flex items-center justify-between flex-nowrap gap-8 h-48 px-10 rounded-lg border border-neutral-100/10"
          >
            <div class="flex items-center gap-8 flex-nowrap">
              <q-icon
                name="svguse:#icon_star_filled"
                class="text-neutral-40 size-20 -translate-y-2"
              />
              <span class="text-headline-4 text-neutral-70">
                Pontuação Atual
              </span>
            </div>

            <span class="text-headline-2 text-neutral-100">
              {{ fRowValue(item?.current_points) }}
            </span>
          </div>

          <div
            class="flex items-center justify-between flex-nowrap gap-8 h-48 px-10 rounded-lg border border-neutral-100/10"
          >
            <div class="flex items-center gap-8 flex-nowrap">
              <q-icon
                name="svguse:#icon_rocket"
                class="text-neutral-40 size-20 -translate-y-2"
              />
              <span class="text-headline-4 text-neutral-70">
                Pontuação Futura
              </span>
            </div>

            <span class="text-headline-2 text-neutral-100">
              {{ fRowValue(item?.future_points) }}
            </span>
          </div>
        </div>

        <q-icon
          name="svguse:#icon_info_circle"
          class="text-neutral-70 size-24 cursor-pointer"
        >
          <q-tooltip
            anchor="top middle"
            self="bottom middle"
            class="bg-neutral-100 text-white"
          >
            Dicas rápidas personalizadas para melhorar seu desempenho
            na Copa.
          </q-tooltip>
        </q-icon>
      </div>
    </div>

    <OTable ref="tableRef" :columns="columns" :rows="item?.quickWins">
      <template #body="_props">
        <q-tr :props="_props" class="!h-[3.625rem]">
          <q-td key="factor">
            {{ _props.row.factor }}
          </q-td>
          <q-td key="current" auto-width class="min-w-[6.25rem]">
            {{ fRowValue(_props.row.current) }}
          </q-td>
          <q-td key="target" auto-width class="min-w-[6.25rem]">
            {{ fRowValue(_props.row.target) }}
          </q-td>
          <q-td key="points" auto-width>
            {{ fRowValue(_props.row.points) }}
          </q-td>
          <q-td key="link" auto-width class="w-[6.25rem] text-center">
            <OButton
              size="md"
              disabled
              tertiary
              icon="arrow_outward"
              class="size-[2.375rem] !min-h-0 !p-0"
            />
          </q-td>
        </q-tr>
      </template>
      <template #bottom />
    </OTable>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import OTable from 'components/Table/OTable.vue'
import TextIcon from 'components/Text/TextIcon.vue'
import OButton from 'components/Button/OButton.vue'

defineProps({
  titleSmall: {
    type: Boolean,
    default: false,
  },
  item: {
    type: Object,
    required: true,
  },
})

const fRowValue = (v) => {
  if (String(v).includes('.')) {
    return Number(v).toFixed(1).replace('.', ',')
  }

  return v
}

const tableRef = ref(null)

const columns = [
  {
    name: 'factor',
    label: 'Top Factors',
    align: 'left',
  },
  {
    name: 'current',
    label: 'Atual',
    align: 'left',
  },
  {
    name: 'target',
    label: 'Target',
    align: 'left',
  },
  {
    name: 'points',
    label: 'Pontos',
    align: 'left',
  },
  {
    name: 'link',
    label: 'Best Practices',
    align: 'center',
  },
]
</script>

<style scoped lang="sass">
:deep(.q-table thead tr th)
  @apply text-headline-3 bg-[#fafafa] text-neutral-70 last:text-wrap

:deep(.q-table tbody tr td)
  @apply text-headline-3 text-neutral-100
</style>
